import { Mail, Phone, StickyNote, Users, type LucideIcon } from 'lucide-react'
import type { ActivityType, LastContactKind } from '../types'

/** ED-06, design §2.7: call is "Gesprek", meeting "Meeting", email "E-mail (gelogd)". */
export const ACTIVITY_LABELS: Record<ActivityType, string> = {
  note: 'Notitie',
  call: 'Gesprek',
  meeting: 'Meeting',
  email: 'E-mail (gelogd)',
}

export const ACTIVITY_ICONS: Record<ActivityType, LucideIcon> = {
  note: StickyNote,
  call: Phone,
  meeting: Users,
  email: Mail,
}

export const LAST_CONTACT_LABELS: Record<LastContactKind, string> = {
  gesprek: 'gesprek',
  meeting: 'meeting',
  email: 'e-mail (gelogd)',
  mail_in: 'e-mail ontvangen',
  mail_uit: 'e-mail verstuurd',
}

export const SOURCE_LABELS: Record<string, string> = {
  handmatig: 'Handmatig',
  import: 'Import',
  scan: 'Visitekaartje',
  migratie: 'Migratie',
}

/** The role on "Op het platform": a founder, or a contact person of the startup. */
export function startupRoleLabel(role: string): string {
  return role === 'founder' ? 'Founder' : 'Contactpersoon'
}
